import { Routes } from '@angular/router';
import { NavigationComponent } from './core/components/navigation/navigation.component';
import { HomeComponent } from './core/components/home/home.component';
import { RolesGuard } from './auth/guards/roles.guard';
import { AngularFireAuthGuard, redirectUnauthorizedTo } from '@angular/fire/compat/auth-guard';
import { AuthGuard } from './auth/guards/auth.guard';
import { appInitResolver } from './core/resolvers/app-init.resolver';
import { PageNotFoundComponent } from './core/components/page-not-found/page-not-found.component';
import { AnonymousGuard } from './auth/guards/anonymous-guard.guard';
import { PhoneLoginAndVerificationComponent } from './auth/components/phone-login-and-verification/phone-login-and-verification.component';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['login']);

export const appRoutes: Routes = [
  {
    path: 'app',
    pathMatch: 'prefix',
    canActivate: [AuthGuard],
    resolve: {
      // ✅ Single master resolver that initializes everything in correct order
      appInit: appInitResolver,
    },
    component: NavigationComponent,
    children: [
      {
        path: 'warehouse-orders',
        canActivate: [RolesGuard],
        loadChildren: () => import('./warehouse-orders/warehouse-orders.routes').then((m) => m.warehouseOrdersRoutes),
        data: {
          roles: ['ADMIN', 'WAREHOUSEMANAGER', 'ACCOUNTANT', 'WAREHOUSECLERK'],
        },
      },
      {
        path: 'users-management',
        canActivate: [RolesGuard],
        loadChildren: () => import('./settings/settings.routes').then((m) => m.settingsRoutes),
        data: {
          roles: ['ADMIN'],
        },
      },
      {
        path: 'salesrep',
        canActivate: [RolesGuard],
        loadChildren: () => import('./salesrep/salesrep.routes').then((m) => m.salesrepRoutes),
        data: {
          roles: ['ADMIN', 'SALESREP'],
        },
      },
      {
        path: 'procurement',
        canActivate: [RolesGuard],
        loadChildren: () => import('./procurement/procurement.routes').then((m) => m.procurementRoutes),
        data: {
          roles: ['ADMIN', 'PROCUREMENTMANAGER'],
        },
      },
      {
        path: 'expenses',
        loadChildren: () => import('./expenses/expenses.routes').then((m) => m.expensesRoutes),
      },
      {
        path: 'profile',
        loadChildren: () => import('./profile/profile.routes').then((m) => m.profileRoutes),
      },
      {
        path: 'timesheets',
        loadChildren: () => import('./timesheets/timesheet.routes').then((m) => m.timesheetRoutes),
      },
      {
        path: 'home',
        component: HomeComponent,
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
    ],
  },
  { path: 'login', pathMatch: 'full', component: PhoneLoginAndVerificationComponent, canActivate: [AnonymousGuard] },
  {
    path: 'account',
    canActivate: [AngularFireAuthGuard],
    loadChildren: () => import('./account/account.routes').then((m) => m.accountRoutes),
  },
  { path: '', redirectTo: '/app/home', pathMatch: 'full' },
  {
    path: '**',
    pathMatch: 'full',
    component: PageNotFoundComponent,
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
];
